import { Link } from "react-router-dom";
import { Motif } from "./Motif";
import { useContent } from "../lib/content";

export default function Footer() {
  const { content: c } = useContent();
  return (
    <footer
      className="bg-[var(--srishti-bg-alt)] border-t border-[var(--srishti-border)] mt-24"
      data-testid="site-footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <Motif className="text-[var(--srishti-gold)]" />
            <span className="font-serif-display text-3xl text-[var(--srishti-maroon)]">
              {c.brand_name}
            </span>
          </div>
          <p className="mt-4 text-sm text-[var(--srishti-text-secondary)] max-w-md leading-relaxed">
            {c.footer_tagline}
          </p>
        </div>

        <div>
          <p className="eyebrow mb-4">Explore</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop">Shop all</Link></li>
            <li><Link to="/shop?category=statues">Statues &amp; Figurines</Link></li>
            <li><Link to="/shop?category=rosary">Rosaries</Link></li>
            <li><Link to="/guides">Sacrament Guides</Link></li>
            <li><Link to="/admin">Admin</Link></li>
          </ul>
        </div>

        <div>
          <p className="eyebrow mb-4">Visit</p>
          <p className="text-sm text-[var(--srishti-text-secondary)] leading-relaxed">
            {c.brand_name} {c.brand_tagline}<br />
            {c.store_address}<br />
            {c.store_hours}
          </p>
        </div>
      </div>
      <div className="border-t border-[var(--srishti-border)] py-5 text-center text-xs text-[var(--srishti-text-secondary)] tracking-widest uppercase">
        © {new Date().getFullYear()} {c.brand_name} · Crafted with reverence
      </div>
    </footer>
  );
}
